// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { accountOverviewStyles } from "@turnerBlueprint/App/Widgets/MyAccount/AccountOverview";
import { color, linkArrowStyle, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

accountOverviewStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 8px;
    `,
};

accountOverviewStyles.titleSection = {
    css: css`
        display: flex;
        align-items: baseline;

        ${xScreen("lte", "xs")} {
            margin-bottom: 16px;
            width: 100%;
        }
    `,
};

accountOverviewStyles.greetingTitle = {
    variant: "p",
    size: "14px",
    lineHeight: "22px",
    css: css`
        margin-right: 8px;
        margin-bottom: 0;
    `,
};

accountOverviewStyles.firstName = {
    forwardAs: "h2",
    variant: "h4",
    css: css`
        margin-bottom: 0;
        margin-right: 20px;
        line-height: 20px;
        ${xScreen("lte", "xs")} {
            font-size: 20px;
            line-height: 28px;
        }
    `,
};

accountOverviewStyles.customerNumber = {
    variant: "h6",
    forwardAs: "span",
    css: css`
        margin-bottom: 0;
    `,
};

accountOverviewStyles.link = linkArrowStyle();
